<script lang="ts">
  let cssClass: string | undefined | null = undefined
  export { cssClass as class }
</script>

<p class="alert-body text-general-default-text font-medium-400 {cssClass}">
  <slot />
</p>
